export default {
  brand: "BasetaoSheet",
  nav: {
    spreadsheet: "Spreadsheet",
    guides: "Leitfäden",
    categories: "Kategorien",
    review: "Bewertung",
    shipping: "Versand",
    home: "Startseite",
    faq: "FAQ",
    shoppingGuide: "Einkaufsführer",
    visitMain: "Hauptwebsite besuchen",
  },
  search: {
    placeholder: "Basetao Spreadsheet, Verkäufer, Versand suchen...",
  },
  cta: {
    basetaoSpreadsheet: "Basetao Spreadsheet",
    buyNow: "Jetzt kaufen",
    visitMain: "Hauptwebsite besuchen",
    explore: "Entdecken",
  },
  lang: {
    label: "Sprache",
    en: "English",
    fr: "Français",
    de: "Deutsch",
    es: "Español",
    pt: "Português",
  },
  notFound: {
    title: "Seite nicht gefunden",
    subtitle: "Die gesuchte Seite existiert leider nicht oder wurde möglicherweise verschoben.",
    backHome: "Zurück zur Startseite",
  },
  categories: {
    title: "Produktkategorien durchsuchen",
    subtitle: "Entdecken Sie jede im Spreadsheet abgedeckte Produktgruppe, jeweils mit dem Hauptkatalog verknüpft.",
    shoes: "Schuhe",
    hoodies: "Hoodies / Sweatshirts",
    tshirts: "T-Shirts",
    jackets: "Jacken",
    pants: "Hosen / Shorts",
    headwear: "Kopfbedeckungen",
    sets: "Sets",
    underwear: "Unterwäsche",
    jersey: "Trikots",
    accessories: "Accessoires",
    bags: "Taschen",
    belts: "Gürtel",
    perfumes: "Parfums",
    other: "Sonstiges",
    empty: "Keine Kategorien entsprechen Ihrer Suche.",
  },
  footer: {
    tagline: "Eine unabhängige Ressourcen-Plattform für Basetao Spreadsheet Leitfäden, Verkäufer, Versand, Gutscheine und Sicherheitstipps.",
    resources: "Ressourcen",
    quickLinks: "Schnellzugriff",
    disclaimer: "Diese Website ist eine unabhängige Informationsquelle und nicht mit Basetao verbunden. Produktlinks führen zur Hauptwebsite.",
    copyright: "© 2026 BasetaoSheet. Alle Rechte vorbehalten.",
    privacy: "Datenschutz",
    terms: "AGB",
    contact: "Kontakt",
  },
};